const customers = (state) => state.customers;

const getCustomerById = (state) => (id) => state.customers[id];

const forceIntersect = (state) => state.force_intersect;

const hasCustomerById = (state) => (id) => typeof state.customers[id] !== "undefined";

const user = (state) => state.user;

const dossierdataCalendarDisabled = (state) => state.dossierdata_calendar_disabled;
const onlineAfsprakenEnabled = (state) => state.online_afspraken_enabled;

const isInstancePage = (state) => {
  if (!state.instance) return false;
  if ("id" in state.instance && ("type" in state.instance || "class" in state.instance)) {
    return true;
  }
  return false;
};

const isCategoryPage = (state) => !!state.category_id;

export default {
  isInstancePage,
  isCategoryPage,
  customers,
  getCustomerById,
  hasCustomerById,
  forceIntersect,
  user,
  dossierdataCalendarDisabled,
  onlineAfsprakenEnabled,
};
